import "./Dashboard.css";
import { BiBriefcase } from "react-icons/bi";
import { BsBriefcaseFill } from "react-icons/bs";
import BoxAnalysis from "./dashboardComponents/BoxAnalysis";
import { Link, useNavigate } from "react-router-dom";
import { FaCaretRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {
  useGetDashboardOverViewQuery,
  useGetDashJobApplicationQuery,
  useGetJobsAlertQuery,
  useGetJobsByStatusQuery,
} from "../../store/query/dashboard";
import moment from "moment";
import { FaArrowRightLong } from "react-icons/fa6";
import CustomButton from "../../components/customButton/CustomButton";
import { config } from "../../config";
import { _currency_format, _figure_format } from "../../utils";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { useTypedSelector } from "../../hook/useTypedSelector";
import { useEffect, useMemo } from "react";

const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useTypedSelector((store) => store.appUser);

  const getStatus = (status) => {
    if (status === "1") {
      return "applied";
    } else if (status === "2") {
      return "shortlisted";
    } else if (status === "3") {
      return "shortlisted";
    } else if (status === "5") {
      return "in-progress";
    } else if (status === "6") {
      return "completed";
    } else if (status === "4") {
      return "declined";
    }
  };

  const {
    data: JobAlerts,
    isLoading: isLoadingAlerts,
    refetch: refetchJobAlerts,
  } = useGetJobsAlertQuery({
    acc_type: user?.account_type,
  });
  const {
    data: jobsApp,
    isLoading: isLoadingJobApp,
    refetch: refetchJobsApp,
  } = useGetDashJobApplicationQuery({
    acc_type: user?.account_type,
  });

  const { data: overview, refetch: refetchOverview } =
    useGetDashboardOverViewQuery({
      acc_type: user?.account_type,
    });

  const {
    data: openJobs,
    isLoading: isLoadingOpenJobs,
    refetch: refetchOpenJobs,
  } = useGetJobsByStatusQuery({
    acc_type: user?.account_type,
    type: "open",
  });
  const {
    data: ongoingJobs,
    isLoading: isLoadingOngoing,
    refetch: refetchOngoingJobs,
  } = useGetJobsByStatusQuery({
    acc_type: user?.account_type,
    type: "ongoing",
  });

  const loading =
    isLoadingAlerts || isLoadingJobApp || isLoadingOpenJobs || isLoadingOngoing;

  const count =
    JobAlerts?.data?.allJob?.length || openJobs?.OpenJobs?.length || 0;

  const settingSliders = useMemo(() => {
    return {
      dots: true,
      infinite: count > 3,
      slidesToShow: Math.min(3, count),
      slidesToScroll: 1,
      speed: 500,
      arrows: false,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: Math.min(2, count),
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
  }, [count]);

  useEffect(() => {
    refetchJobAlerts();
    refetchJobsApp();
    refetchOverview();
    refetchOpenJobs();
    refetchOngoingJobs();
  }, [
    refetchJobAlerts,
    refetchJobsApp,
    refetchOverview,
    refetchOpenJobs,
    refetchOngoingJobs,
    count,
  ]);

  console.log("job-apps", jobsApp?.data?.allApplication);

  return (
    <div className="dashboard-container">
      <div className="dashboard-right">
        {/* dashboard main content */}
        <div className="dashboard-right-bottom">
          {/* info box */}
          <div className="info-box">
            <BoxAnalysis
              num={_figure_format(
                Number(
                  overview?.applicationRecieved
                    ? overview?.applicationRecieved
                    : overview?.applicationSent
                      ? overview?.applicationSent
                      : 0,
                ),
              )}
              title={
                user.account_type === "organisation"
                  ? "Application Received"
                  : "Application Sent"
              }
              bg={"#FFF2E5"}
              icon={
                <BiBriefcase style={{ color: "#F5A656", fontSize: "25px" }} />
              }
            />
            <BoxAnalysis
              num={_figure_format(
                Number(overview?.completedJob ? overview?.completedJob : 0),
              )}
              title="Completed Jobs"
              bg={"#90ECDE33"}
              icon={
                <BsBriefcaseFill
                  style={{ color: "#00B297", fontSize: "25px" }}
                />
              }
            />
            <BoxAnalysis
              num={_currency_format(
                Number(overview?.totalPayout ?? overview?.totalEarning ?? 0),
                "NGN",
              )}
              title={
                user.account_type === "organisation"
                  ? "Total Payout"
                  : "Total Earning"
              }
              bg={"#FFE5E8"}
              icon={
                <div
                  style={{
                    padding: "8px",
                    backgroundColor: "#D6FCFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <RiMoneyDollarCircleFill
                    style={{ color: "#5ECFD6", fontSize: "18px" }}
                  />
                </div>
              }
            />
          </div>

          <div className="exploreMore-container">
            <div>
              <div className="background-slider">
                <div className="slide slide1"></div>
                <div className="slide slide2"></div>
                <div className="slide slide3"></div>
                <div className="slide slide4"></div>
              </div>
            </div>
            <div className="exploreMore-bottom">
              <h4>
                {user.account_type === "organisation"
                  ? "Open Jobs"
                  : "Job Alerts"}
              </h4>

              <div className="explore-bg">
                {user?.account_type === "individual" &&
                  JobAlerts?.data?.allJob?.length > 0 && (
                    <Slider {...settingSliders} className="exploreMore-jobs">
                      {JobAlerts?.data?.allJob.slice(0, 9)?.map((job) => {
                        const logo =
                          job.logo && `${config.getPublicImages}/${job.logo}`;
                        return (
                          <div key={job.id} className="exploreMore-Jobs-box">
                            <div className="exploreMore-title-box">
                              <div className="title">
                                <h4>{job.title}</h4>
                                <span>Rate:N{job.hourly_rate}/hr</span>
                              </div>
                              <div className="image">
                                <img src={logo} alt="img" />
                              </div>
                            </div>
                            <div className="desc">
                              <p>
                                {job.description.length > 40
                                  ? job.description.slice(0, 40) + "..."
                                  : job.description}
                              </p>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div className="findJobs-button">
                                <CustomButton
                                  variant="outline"
                                  title="Details"
                                  customStyles={{
                                    width: "70px",
                                    height: "25px",
                                    marginTop: "0",
                                    fontSize: "14px",
                                    borderRadius: "5px",
                                    borderWidth: "0px",
                                    paddingLeft: "0px",
                                  }}
                                  onClick={() => {
                                    navigate(`/joblistings/${job.id}`);
                                  }}
                                />
                              </div>
                              <div className="applicants">
                                <h5>
                                  {job.applicants <= 1
                                    ? `${job.applicants ?? 0} Applicant`
                                    : `${job.applicants ?? 0} Applicants`}
                                </h5>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  )}

                {user?.account_type === "organisation" &&
                  openJobs?.OpenJobs?.length > 0 && (
                    <Slider {...settingSliders} className="exploreMore-jobs">
                      {openJobs?.OpenJobs.slice(0, 9)?.map((job) => {
                        const logo =
                          job.logo && `${config.getPublicImages}/${job.logo}`;
                        return (
                          <div key={job.id} className="exploreMore-Jobs-box">
                            <div className="exploreMore-title-box">
                              <div className="title">
                                <h4>{job.title}</h4>
                                <span>Rate:N{job.hourly_rate}/hr</span>
                              </div>
                              <div className="image">
                                <img src={logo} alt="img" />
                              </div>
                            </div>
                            <div className="desc">
                              <p>
                                {job.description.length > 40
                                  ? job.description.slice(0, 40) + "..."
                                  : job.description}
                              </p>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div className="findJobs-button">
                                <CustomButton
                                  variant="outline"
                                  title="Details"
                                  customStyles={{
                                    width: "70px",
                                    height: "25px",
                                    marginTop: "0",
                                    fontSize: "14px",
                                    borderRadius: "5px",
                                    borderWidth: "0px",
                                    paddingLeft: "0px",
                                  }}
                                  onClick={() => {
                                    navigate(`/joblistings/${job.id}`);
                                  }}
                                />
                              </div>
                              <div className="applicants">
                                <h5>
                                  {job.applicants <= 1
                                    ? `${job.applicants ?? 0} Applicant`
                                    : `${job.applicants ?? 0} Applicants`}
                                </h5>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  )}

                {loading && (
                  <div style={{ marginTop: "30px", marginLeft: "5px" }}>
                    <p>Loading...</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* explore more jobs */}

          {/* applications info*/}
          <div className="applications-info-container">
            <h4>
              {user.account_type === "organisation"
                ? "Ongoing Jobs"
                : "My Applications"}
            </h4>

            <div className="desktop-view">
              {/* head */}
              <div className="applications-info-heading">
                <span className="head head-1">
                  {user.account_type === "organisation"
                    ? "Company / Facility"
                    : "Company Name"}
                </span>
                <span style={{ width: "16%" }} className="head">
                  {user.account_type === "organisation" ? "Division" : "Status"}
                </span>
                <span style={{ width: "16%" }} className="head">
                  {user.account_type === "organisation"
                    ? "Date"
                    : "Date Applied"}
                </span>
                <span style={{ width: "13%" }} className="head">
                  Action
                </span>
              </div>

              {jobsApp?.data?.allApplication &&
                jobsApp?.data?.allApplication?.map((app) => {
                  const logo =
                    app.logo && `${config.getPublicImages}/${app.logo}`;
                  return (
                    <div key={app.date_applied}>
                      <div className="applications-info-content">
                        <div className="applications-info-content-box">
                          <span className="content-1">
                            <span className="img">
                              <img src={logo} alt="hos-img" />
                            </span>
                            <span className="title">
                              <h6>{app.company_name}</h6>
                            </span>
                          </span>
                          <div style={{ width: "16%" }}>
                            <span className={`status ${getStatus(app.status)}`}>
                              {getStatus(app.status)}
                            </span>
                          </div>
                          <span style={{ width: "16%" }} className="date">
                            {moment(app.date_applied).format("LL")}
                          </span>
                          <Link
                            style={{ width: "13%" }}
                            className="date"
                            to={`/activity/${app.status}`}
                          >
                            <FaArrowRightLong
                              style={{ color: "#20a4d3", fontSize: 20 }}
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {user.account_type === "organisation" &&
                ongoingJobs?.OngoingJobs &&
                ongoingJobs?.OngoingJobs?.slice(0, 10)?.map((app) => {
                  return (
                    <div key={app.date_applied}>
                      <div className="applications-info-content">
                        <div className="applications-info-content-box">
                          <span className="content-1">
                            <span className="title">
                              <h6>{app.company_name}</h6>
                            </span>
                          </span>
                          <div style={{ width: "16%" }}>
                            <span>{app.division}</span>
                          </div>
                          <span style={{ width: "16%" }} className="date">
                            {moment(app.date_applied).format("LL")}
                          </span>
                          <Link
                            style={{ width: "13%" }}
                            className="date"
                            to={`/applicants/${app.job_id}/3`}
                          >
                            <FaArrowRightLong
                              style={{ color: "#20a4d3", fontSize: 20 }}
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {loading && (
                <div style={{ marginTop: "30px", marginLeft: "5px" }}>
                  <p>Loading...</p>
                </div>
              )}
            </div>

            <div className="mobile-application-jobs">
              <div className="all-jobs-app">
                {jobsApp?.data?.allApplication &&
                  jobsApp?.data?.allApplication?.map((app) => {
                    return (
                      <div key={app.date_applied} className="job-single">
                        <div className="flex">
                          <span className="label">Company Name</span>
                          <div
                            style={{
                              width: "50%",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                            }}
                          >
                            <span className="content-1">
                              <span className="title">
                                <h6>{app.company_name}</h6>
                              </span>
                            </span>
                          </div>
                        </div>

                        <div className="flex">
                          <span className="label">Status</span>
                          <div
                            style={{
                              width: "50%",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                            }}
                          >
                            <span className="status">
                              {" "}
                              {getStatus(app.status)}
                            </span>
                          </div>
                        </div>

                        <div className="flex">
                          <span className="label">Date Applied</span>
                          <div
                            style={{
                              width: "50%",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                            }}
                          >
                            <span className="date">
                              {moment(app.date_applied).format("LL")}
                            </span>
                          </div>
                        </div>

                        <div className="flex">
                          <span className="label">Action</span>
                          <div
                            style={{
                              width: "50%",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Link
                              className="date"
                              to={`/activity/${app.status}`}
                            >
                              <FaCaretRight
                                style={{ color: "blue", fontSize: 20 }}
                              />
                            </Link>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                {ongoingJobs?.OngoingJobs &&
                  ongoingJobs?.OngoingJobs?.slice(0, 10)?.map((app) => {
                    return (
                      <div key={app.date_applied} className="job-single">
                        <div className="flex">
                          <span className="label">
                            {user.account_type === "organisation"
                              ? "Company/Facility"
                              : "Company Name"}
                          </span>
                          <div
                            style={{
                              width: "50%",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                            }}
                          >
                            <span className="content-1">
                              <span className="title">
                                <h6>{app.company_name}</h6>
                              </span>
                            </span>
                          </div>
                        </div>

                        <div className="flex">
                          <span className="label">
                            {user.account_type === "organisation"
                              ? "Division"
                              : "Status"}
                          </span>
                          <div
                            style={{
                              width: "50%",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                            }}
                          >
                            <span>{app.division}</span>
                          </div>
                        </div>

                        <div className="flex">
                          <span className="label">
                            {user.account_type === "organisation"
                              ? "Date"
                              : "Date Applied"}
                          </span>
                          <div
                            style={{
                              width: "50%",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                            }}
                          >
                            <span className="date">
                              {moment(app.date_applied).format("LL")}
                            </span>
                          </div>
                        </div>

                        <div className="flex">
                          <span className="label">Action</span>
                          <div
                            style={{
                              width: "50%",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Link
                              className="date"
                              to={`/applicants/${app.job_id}/3`}
                            >
                              <FaCaretRight
                                style={{ color: "blue", fontSize: 20 }}
                              />
                            </Link>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                {loading && (
                  <div style={{ marginTop: "30px", marginLeft: "5px" }}>
                    <p>Loading...</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
